import React from 'react';
import styled from 'styled-components';
import { Image, BackgroundImage } from '../Image';
import { RichH2, RichH4, RichP1 } from '../Typography';
import { CTALink } from '../Link';
import media from '../../utils/media';
import { ComponentHeader } from '../ComponentWrappers';
import { Container, ContentBox } from './StaticContentContainers';
import { isLogoTypeSmall } from '../../utils/variations';
import { isFieldValid } from '../../utils/validation';
import { getFieldValue, getParsedField, defineRegionFieldFromTitle, defineAriaLabelFromTitle, } from '../../utils/helpers';
import { populateCTAGTM } from '../../utils/gtm';
const StyledBackgroundImage = styled(BackgroundImage) `
  ${media.mobile} {
    position: relative !important;
    height: 250px;
  }
`;
const ContentSubtitle = styled(RichH4) `
  width: fit-content;
  color: ${({ theme }) => theme.primaryRed};
  border-bottom: 1px solid ${({ theme }) => theme.greyDarkMedium};
  margin-bottom: 10px;
  padding-bottom: 5px;
`;
const ContentTitle = styled(RichH2) `
  width: 100%;
  margin-bottom: 10px;
`;
const ContentBodyText = styled(RichP1) `
  width: 100%;
  margin-bottom: 20px;
`;
const LargeLogo = styled(Image) `
  width: auto;
  height: 150px;
  margin-bottom: 30px;

  ${media.mobile} {
    height: 112.5px;
    margin-bottom: 20px;
  }
`;
const SmallLogo = styled(Image) `
  width: auto;
  height: 60px;
  margin-bottom: 20px;

  ${media.mobile} {
    height: 45px;
  }
`;
export const StaticContent = ({ fields }) => {
    if (!fields) {
        console.warn('Static Content component requires fields to be provided');
        return null;
    }
    const { componentTitle, componentSubtitle, contentAlignment, contentTitle, contentSubtitle, contentBodyText, ctaLink, ctaLinkText, ctaType, desktopImage, mobileImage, logo, logoType, componentBottomMargin, ariaLabel, } = fields;
    const alignment = getFieldValue(contentAlignment);
    const isLogoValid = isFieldValid(logo, 'src');
    const isLogoTypeValid = isFieldValid(logoType);
    const hasLargeLogo = isLogoValid && isLogoTypeValid && !isLogoTypeSmall(logoType);
    const hasSmallLogo = (isLogoValid && isLogoTypeSmall(logoType)) || (isLogoValid && !isLogoTypeValid);
    const hasContentTitle = isFieldValid(contentTitle) && !hasLargeLogo;
    const hasContentSubTitle = isFieldValid(contentSubtitle) && !isLogoValid;
    const hasCTA = isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText);
    const validatedCTAType = isFieldValid(ctaType) ? ctaType : { value: 'TERTIARY' };
    const imageAlt = getFieldValue(desktopImage, 'alt');
    // parsed values for custom tags
    const parsedTitle = getParsedField(contentTitle);
    const parsedSubtitle = getParsedField(contentSubtitle);
    const parsedBodyText = getParsedField(contentBodyText);
    return (React.createElement(ComponentHeader, { title: componentTitle, subtitle: componentSubtitle, ariaLabel: ariaLabel },
        React.createElement(Container, { role: defineRegionFieldFromTitle(componentTitle), "aria-label": defineAriaLabelFromTitle(componentTitle, ariaLabel), alignment: alignment, hasBottomMargin: componentBottomMargin.value },
            React.createElement(StyledBackgroundImage, { role: "img", desktopImage: desktopImage, mobileImage: mobileImage, "aria-label": imageAlt }),
            React.createElement(ContentBox, { alignment: alignment },
                hasSmallLogo && React.createElement(SmallLogo, { media: logo }),
                hasLargeLogo && React.createElement(LargeLogo, { media: logo }),
                hasContentSubTitle && React.createElement(ContentSubtitle, { field: parsedSubtitle }),
                hasContentTitle && React.createElement(ContentTitle, { field: parsedTitle }),
                contentBodyText && React.createElement(ContentBodyText, { field: parsedBodyText }),
                hasCTA && (React.createElement(CTALink, Object.assign({ field: ctaLink, textField: ctaLinkText, typeField: validatedCTAType }, populateCTAGTM(fields))))))));
};
